import { get, post, jsonPost, fileUpload } from '../axios'
import store from '@/store'
import { dataToString } from '@/utils/url'

// 获取帖子详情
const getPostDetail = (id) => {
  return get('/activity/timeline/post', { id, token: store.getters.getToken })
}

// 获取帖子跟进进展
const getProgressById = (postId) => {
  return get('/activity/timeline/getProgressById', { postId })
}

/**
 * 帖子评论
 * @param {*} postId 帖子id
 * @param {*} content 内容
 */
const submitPostComment = (postId, content) => {
  return post('/activity/timeline/post/comment', { postId, content, token: store.getters.getToken })
}

/**
 * 帖子评论
 * @param {*} params
 * @returns
 */
const submitComment = (params) => {
  return post(`/activity/timeline/post/comment?${dataToString(params)}`)
}

/**
 * 帖子点赞
 * @param {*} postId
 * @param {*} isLove
 * @returns
 */
const likePost = (postId, isLove) => {
  return post('/activity/timeline/post/love', { postId, isLove, token: store.getters.getToken })
}

/**
 * 评论点赞
 * @param {*} commentId 评论id
 * @param {*} isLove 是否点赞
 * @param {*} postId 帖子id
 * @returns
 */
const likeComment = (commentId, isLove, postId) => {
  return post('/activity/timeline/post/comment/love', { commentId, isLove, postId, token: store.getters.getToken })
}

/**
 * 获取帖子评论列表
 * @param {*} postId 帖子id, parentId 父评论id, page 页码, order 排序类型
 */
const getPostComments = ({ postId, parentId, page, order, pageSize }) => {
  return get('/activity/timeline/post/comments', { postId, parentId, page, order, pageSize: pageSize ? pageSize : 20, token: store.state.token })
}

/**
 * 保存帖子
 * @param {*} params address地址 anonymous是否匿名 contact联系方式 contactPerson联系人 content内容 location经纬度 title标题 type类型
 * @param {*} files coverPath封面图 filePath文件地址 height高度 width宽度 type类型
 * @returns
 */
const savePost = (params) => {
  return jsonPost(`/activity/timeline/post?token=${store.state.token}`, params)
}

/**
 * 获取我的帖子
 * @param {*} type 类型
 * @param {*} page 页码
 * @returns
 */
const getMyPosts = (params) => {
  return get(`/activity/timeline/poster/posts`, { ...params, token: store.state.token })
}

/**
 * 获取表单配置选项
 */
const getConfigList = (tagId) => {
  return get(`/activity/timeline/tag/config/list`, { tagId: tagId, token: store.state.token })
}

/**
 * 获取选项
 */
const getPickerList = (optionId) => {
  return get(`/activity/timeline/tag/config/options/list`, { configId: optionId, token: store.state.token })
}

/**
 * 文件上传
 */
const uploadFile = (file) => {
  const param = new FormData()
  // param.append('file',file)
  // return fileUpload('/activity/file/upload/notoken',  param  )
  param.append('file', file)
  param.append('token', store.state.token)
  return fileUpload(`/activity/file/upload`, param)
}


/**
 * 提交表单
 */
const configCommit = (param) => {
  return jsonPost(`/activity/timeline/tag/config/commit`, param)
}

export default {
  getPostDetail,
  getProgressById,
  submitPostComment,
  submitComment,
  likePost,
  likeComment,
  getPostComments,
  savePost,
  getMyPosts,
  getConfigList,
  getPickerList,
  uploadFile,
  configCommit
}
